// extracted by mini-css-extract-plugin
module.exports = {"component":"NoCarFound_component__dXiVQ","title":"NoCarFound_title__jFSgL","subtitle":"NoCarFound_subtitle__AwE8f"};